import { jsx as _jsx } from "react/jsx-runtime";
import { Table as AntdTable } from 'antd';
import styled from 'styled-components';
import { TableSkeleton } from 'components/atoms/table';
const StyledTable = styled(AntdTable)`
  .ant-table-ping-right:not(.ant-table-has-fix-right)
    .ant-table-container::after {
    box-shadow: none;
  }

  .ant-table-thead > tr > th {
    background: var(--white-100);
    color: var(--gray-60);
    font-weight: var(--heading-6-weight);
    height: var(--spacing-07);
    padding: 0 var(--spacing-05);
    line-height: var(--spacing-05);
    border-bottom: 1px solid var(--table-border-color);
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid var(--table-border-color);
  }

  .ant-table-column-sorters {
    padding: 0;
  }

  .ant-table-cell-fix-left {
    background: #fffffff2;
  }

  .ant-table-thead > tr > th.ant-table-cell-fix-left {
    background: #ededeff2;
  }
`;
export const Table = (props)=>{
    const { loading, size } = props;
    return loading ? /*#__PURE__*/ _jsx(TableSkeleton, {
        size: size
    }) : /*#__PURE__*/ _jsx(StyledTable, {
        ...props
    });
};
